import axios from "axios";
import * as types from '../constants/ActionTypes'
import { toast } from 'react-toastify';
// Url's
// const updateUserAddrUrl = `${process.env.REACT_APP_API_URL}api/csa-app/update-consumer-address`;
const updateUserAddrUrl = `${process.env.REACT_APP_API_URL}mobileshop/csaprofile/update-consumer-address`;


// Actions
const updateUserAddrRequested = () => ({
  type: types.UPDATEUSERADDR_REQUEST
});

const updateUserAddrSuccess = data => ({
  type: types.UPDATEUSERADDR_SUCCESS,
  data
});

const updateUserAddrFailure = error => ({
  type: types.UPDATEUSERADDR_FAILURE,
  error
});


// API
export const updateUserAddr = ({ connection_id, user_data }) => {
  return dispatch => {
    dispatch(updateUserAddrRequested());
    
    axios.put(updateUserAddrUrl,
      {
        connection_id,
        consumer_mobile_no: user_data.cons_mobile_no,
        consumer_ship_to_address1: user_data.ship_addr_1,
        consumer_ship_to_address2: user_data.ship_addr_2,
        consumer_ship_to_address3: user_data.ship_addr_3,
        consumer_ship_to_town_cd: user_data.ship_town_id,
        consumer_ship_to_state_cd: user_data.ship_state_id,
        consumer_ship_to_country_cd: user_data.ship_country_id,
        consumer_ship_to_town_name: user_data.ship_town_name,
        consumer_ship_to_state_name:user_data.ship_state_name,
        consumer_ship_to_country_name: user_data.ship_country_name,
        consumer_ship_to_pincode: user_data.ship_pin,
        consumer_bill_to_address1: user_data.bill_addr_1,
        consumer_bill_to_address2: user_data.bill_addr_2,
        consumer_bill_to_address3: user_data.bill_addr_3,
        consumer_bill_to_town_cd: user_data.bill_town_id,
        consumer_bill_to_state_cd:user_data.bill_state_id,
        consumer_bill_to_country_cd: user_data.bill_country_id,
        consumer_bill_to_town_name: user_data.bill_town_name,
        consumer_bill_to_state_name:user_data.bill_state_name,
        consumer_bill_to_country_name: user_data.bill_country_name,
        consumer_bill_to_pincode: user_data.bill_pin
      },
      {
        headers: {
          'Accept': 'application/json',
              'Content-Type': 'application/json'
          //'Content-Type': 'application/json; charset=UTF-8'
        }
      })
      .then(res => {
        if (res.data.ack === "Success") {
          setTimeout(() => {
            dispatch(updateUserAddrSuccess(res.data.status.message))
            toast.success(`User Address Updated!`);
          },3000)
        } else if (res.data.ack === "Failure") {
          dispatch(updateUserAddrFailure(res.data.status));
        }
      })
      .catch(err => {
        throw err;
        // dispatch(addTodoFailure(err.message));
      });
  };
};
